export default "__VITE_ASSET__vkQQ5Hg8__"